import React, { useEffect, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import Input from '../../../components/elements/form/input';
import Button from '../../../components/elements/button';
import SelectBox from '../../../components/elements/form/selectBox';
import toast from 'react-hot-toast';
import Loader from '../../../components/loader';
import { useUserApi } from '../../../store/api/hooks/userApiHook';
import Icon from '../../../components/icons';
import Drawer from '../../../components/Drawer';
import ModalWrapper from '../../../components/modalWrapper';

interface UserSettingsFormProps {
    userType?: any;
    onSave?: () => void;
    onCancel?: () => void;
}

type FormValues = {
    permission: Array<{
        userModuleID: string | null;
        userTypeID: string;
        name: string;
        url: string;
        apIs: Array<{ apiurl: string }>;
        entities: Array<{ obj: string, r: boolean, w: boolean, d: boolean, checked?: boolean, disable?: boolean }>;
        isTemplate: boolean;
        checked: boolean;
    }>;
};

const UserSettingsForm: React.FC<UserSettingsFormProps> = ({ userType = null, onSave = () => { }, onCancel = () => { } }) => {
    const { control, handleSubmit, formState: { errors }, reset, setValue, watch } = useForm<FormValues>({
        defaultValues: {
            permission: []
        }
    });

    const userAdditionalSettingsRef: any = useRef();
    const userApi = useUserApi();

    const [showLoader, setShowLoader] = useState<boolean>(false);
    const [selectedUserModule, setSelectedUserModule] = useState<any>(null);
    const permissionWatcher = watch(`permission`)

    const onSubmit = async (data: FormValues) => {
        console.log('User Settings Data:', data);
        const filteredPermissions = data.permission.filter(o => o.checked === true);
        console.log('Filtered Permissions:', filteredPermissions);
        var payload = {
            modules: filteredPermissions.map((o: any) => {
                delete o.checked;
                o.isTemplate = false;
                o.entities = o.entities.filter((o: any) => (!o?.disable || (o?.disable && !o.disable)) && o?.obj && o.obj).map((e: any) => {
                    if (e.checked) {
                        e.r = true;
                        e.w = true;
                        e.d = true;
                    } else {
                        e.r = false;
                        e.w = false;
                        e.d = false;
                    }
                    delete e.checked;
                    if (e?.disable) delete e.disable;
                    return e;
                });
                return o;
            })
        };
        if (filteredPermissions.length < 1) {
            payload = {
                modules: [{
                    userTypeID: userType
                }]
            };
        }
        console.log("Final payload is -> ", payload);
        setShowLoader(true);
        const response: any = await new Promise((resolve, reject) => userApi.saveUserModuleBundle(payload, resolve, reject)).catch(error => null);
        if (response && response?.successful) {
            toast.success(response.message || 'User settings have been saved successfully');
            onSave();
        } else {
            toast.error(response?.message || 'Failed to save user settings, please try again');
        }
        setShowLoader(false);
    };

    const slugifyEntity = (text: string): string => {
        return text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').replace(/--+/g, '-');
    }

    const init_page = async () => {
        setShowLoader(true);
        const permissionsresp: any = await new Promise((resolve, reject) => {
            userApi.getUserModules({ pageSize: 5000, userTypeID: userType }, resolve, reject);
        }).catch((err: any) => {
            return null
        });
        setShowLoader(false);
        console.log("permissionsresp", permissionsresp)
        if (permissionsresp && permissionsresp.hasOwnProperty(`userModules`) && Array.isArray(permissionsresp.userModules)) {
            const checkeddItemsSurce = permissionsresp.userModules.filter((o: any) => o.isTemplate === false);
            //const checkedItems = permissionsresp.userModules.filter((o: any) => o.isTemplate === false);
            //const bind_entity_permissions = { ...entityPermissions };
            const bind_variable: Array<any> = [];
            for await (const [index, o] of permissionsresp.userModules.entries()) {
                if (o.isTemplate === true) {
                    const checkitemindex = checkeddItemsSurce.map((o: any) => o.userTypeName + `#` + o.url).indexOf(o.userTypeName + `#` + o.url);
                    o[`checked`] = checkitemindex > -1;
                    if (o.url === `/`) {
                        o.checked = true;
                    }
                    delete o.userTypeName;
                    delete o.totalRecord;
                    const delkeys = [];
                    delkeys.push(o.entities.findIndex((e: any) => slugifyEntity(e.obj) === `add`));
                    delkeys.push(o.entities.findIndex((e: any) => slugifyEntity(e.obj) === `edit`));
                    delkeys.push(o.entities.findIndex((e: any) => slugifyEntity(e.obj) === `delete`));
                    //const addkey = o.entities.findIndex((e: any) => slugifyEntity(e.obj) === `add`);
                    //const editKey = o.entities.findIndex((e: any) => slugifyEntity(e.obj) === `edit`);
                    //const deleteKey = o.entities.findIndex((e: any) => slugifyEntity(e.obj) === `delete`);
                    //console.log("Addkey / Editkey / DeleteKey", addkey, editKey, deleteKey);
                    const copyEntity = Object.assign([], JSON.parse(JSON.stringify(o.entities)));
                    const filterentities: any[] = [];
                    for await (const [ex, entity] of copyEntity.entries()) {
                        if (delkeys.indexOf(ex) < 0) {
                            filterentities.push(entity);
                        }
                    }
                    if (typeof delkeys[2] !== `undefined` && delkeys[2] > -1)
                        filterentities.unshift(o.entities[delkeys[2]]);
                    else
                        filterentities.unshift({ disable: true });
                    if (typeof delkeys[1] !== `undefined` && delkeys[1] > -1)
                        filterentities.unshift(o.entities[delkeys[1]])
                    else
                        filterentities.unshift({ disable: true });
                    if (typeof delkeys[0] !== `undefined` && delkeys[0] > -1)
                        filterentities.unshift(o.entities[delkeys[0]]);
                    else
                        filterentities.unshift({ disable: true });
                    filterentities.map((k: any) => {
                        k[`checked`] = checkeddItemsSurce[checkitemindex]?.entities.find((e: any) => (e.obj === k.obj && e.r === true && e.w === true && e.d === true)) ? true : false;
                        
                        // Initialize disable property for all entities (if not already set)
                        if (!k.hasOwnProperty('disable')) {
                            k.disable = false;
                        }
                        
                        return k;
                    });

                    // After mapping all entities, set up the dependency logic
                    const canAccessOwnWOEntity = filterentities.find((entity: any) => entity.obj === "Can Access Only Own Task");
                    const canAccessWOByRequestEntity = filterentities.find((entity: any) => entity.obj === "Can Access Tasks where the related Request is owned by self");
                    
                    if (canAccessOwnWOEntity && canAccessWOByRequestEntity) {
                        // Rule 2: If "Can Access Only Own Task" is unchecked, uncheck and disable the dependent one
                        if (!canAccessOwnWOEntity.checked) {
                            canAccessWOByRequestEntity.checked = false;
                            canAccessWOByRequestEntity.disable = true;
                        } else {
                            // Rule 1: If "Can Access Only Own Task" is checked, enable the dependent one
                            canAccessWOByRequestEntity.disable = false;
                        }
                    }
                    //bind_entity_permissions[o.userModuleID] = filterentities;
                    o.entities = filterentities
                    o.displayOrder = o.displayOrder === null ? 9999 : +o.displayOrder;
                    bind_variable.push(o);
                }
            }
            bind_variable.sort((a, b) => a.displayOrder - b.displayOrder);
            //setEntityPermissions(bind_entity_permissions);
            setValue(`permission`, bind_variable);
            console.log("bind_variable", bind_variable);
        }
    };

    useEffect(() => {
        init_page();
    }, []);

    // Handle dependency between "Can Access Only Own Task" and "Can Access Tasks where the related Request is owned by self"
    useEffect(() => {
        if (permissionWatcher && permissionWatcher.length > 0) {
            const updatedPermissions = [...permissionWatcher];
            let hasChanges = false;

            updatedPermissions.forEach((item: any, moduleIdx: number) => {
                if (item.entities && item.entities.length > 0) {
                    // Find the indices of the two specific permissions
                    let canAccessOwnWOIndex = -1;
                    let canAccessWOByRequestIndex = -1;

                    item.entities.forEach((entity: any, entityIdx: number) => {
                        if (entity.obj === "Can Access Only Own Task") {
                            canAccessOwnWOIndex = entityIdx;
                        }
                        if (entity.obj === "Can Access Tasks where the related Request is owned by self") {
                            canAccessWOByRequestIndex = entityIdx;
                        }
                    });

                    // If both permissions exist in this module
                    if (canAccessOwnWOIndex !== -1 && canAccessWOByRequestIndex !== -1) {
                        const canAccessOwnWO = item.entities[canAccessOwnWOIndex]?.checked;
                        const canAccessWOByRequest = item.entities[canAccessWOByRequestIndex];

                        // Rule 1: If "Can Access Only Own Task" is checked, enable "Can Access Tasks where the related Request is owned by self"
                        if (canAccessOwnWO) {
                            if (canAccessWOByRequest?.disable) {
                                updatedPermissions[moduleIdx].entities[canAccessWOByRequestIndex].disable = false;
                                hasChanges = true;
                            }
                        } 
                        // Rule 2: If "Can Access Only Own Task" is unchecked, uncheck and disable "Can Access Tasks where the related Request is owned by self"
                        else {
                            if (!canAccessWOByRequest?.disable || canAccessWOByRequest?.checked) {
                                updatedPermissions[moduleIdx].entities[canAccessWOByRequestIndex].checked = false;
                                updatedPermissions[moduleIdx].entities[canAccessWOByRequestIndex].disable = true;
                                hasChanges = true;
                            }
                        }
                    }
                }
            });

            if (hasChanges) {
                setValue('permission', updatedPermissions);
            }
        }
    }, [
        permissionWatcher?.map(p => 
            p.entities?.filter(e => 
                e.obj === "Can Access Only Own Task" || 
                e.obj === "Can Access Tasks where the related Request is owned by self"
            )?.map(e => `${e.obj}:${e.checked}`)?.join('|')
        )?.join('||'), 
        setValue
    ]);

    return (
        <div className={`relative h-full flex flex-col`}>
            {showLoader && (
                <div className={`absolute p-8 w-full h-full z-[2px] bg-white bg-opacity-30`}>
                    <Loader />
                </div>
            )}
            <form onSubmit={handleSubmit(onSubmit)} className={`${showLoader ? `hidden` : `flex flex-col h-full`}`} noValidate>
                <div className="flex-1 overflow-auto mt-2">
                    <div className="space-y-4">
                        <div>
                            <div className={`flex items-center gap-[2px] tabx-header mb-[2px] sticky top-0 z-[1]`}>
                                <div className={`flex items-center w-[calc(100%-432px)] font-semibold bg-slate-200 border border-[#E5E7EB] min-h-9 max-h-9 px-2 py-1`}>Module</div>
                                <div className={`flex items-center gap-[2px]`}>
                                    <div className={`flex items-center justify-center min-w-28 w-28 max-w-28 font-semibold bg-slate-200 border border-[#E5E7EB] min-h-9 max-h-9 px-2 py-1`}>Enable Page</div>
                                    <div className={`flex items-center justify-center min-w-16 w-16 max-w-16 font-semibold bg-slate-200 border border-[#E5E7EB] min-h-9 max-h-9 px-2 py-1`}>Add</div>
                                    <div className={`flex items-center justify-center min-w-16 w-16 max-w-16 font-semibold bg-slate-200 border border-[#E5E7EB] min-h-9 max-h-9 px-2 py-1`}>Edit</div>
                                    <div className={`flex items-center justify-center min-w-16 w-16 max-w-16 font-semibold bg-slate-200 border border-[#E5E7EB] min-h-9 max-h-9 px-2 py-1`}>Delete</div>
                                    <div className={`flex items-center justify-center min-w-32 w-32 max-w-32 font-semibold bg-slate-200 border border-[#E5E7EB] min-h-9 max-h-9 px-2 py-1`}>Special Access</div>
                                </div>
                            </div>
                            {permissionWatcher.map((item: any, idx: number) => (
                                <div key={`item-${idx}`} className='flex gap-[2px] items-center bg-slate-50 rounded mb-[2px]'>
                                    <div className={`flex items-center font-normal text-[13px] w-[calc(100%-432px)] min-h-8 max-h-8 border border-[#E5E7EB] px-2 py-1`}>{item.name}</div>
                                    <div className={`flex items-center gap-[2px]`}>
                                        <div className={`flex items-center justify-center gap-4 min-w-28 w-28 max-w-28 min-h-8 max-h-8 border border-[#E5E7EB] px-2 py-1 ${item.url === `/` ? `pointer-events-none opacity-50` : ``}`}>
                                            <label className="flex items-center gap-3">
                                                <Controller
                                                    name={`permission.${idx}.checked`}
                                                    control={control}
                                                    render={({ field }) => (
                                                        <button
                                                            type="button"
                                                            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none ${field.value ? 'bg-green-700' : 'bg-gray-300'
                                                                }`}
                                                            onClick={() => field.onChange(!field.value)}
                                                            onBlur={field.onBlur}
                                                            name={field.name}
                                                            ref={field.ref as React.Ref<HTMLButtonElement>}
                                                            aria-pressed={field.value}
                                                        >
                                                            <span
                                                                className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform ${field.value ? 'translate-x-5' : 'translate-x-1'
                                                                    }`}
                                                            />
                                                        </button>
                                                    )}
                                                />
                                            </label>
                                        </div>
                                        <div className={`flex items-center justify-center min-w-16 w-16 max-w-16 min-h-8 max-h-8 border border-[#E5E7EB] ${!item.checked ? `pointer-events-none opacity-50` : ``}`}>
                                            {typeof item.entities[0] !== 'undefined' && (!item.entities[0]?.disable || (item.entities[0]?.disable && !item.entities[0].disable)) ? (
                                                <Controller
                                                    name={`permission.${idx}.entities.${0}.checked`}
                                                    control={control}
                                                    render={({ field }) => (
                                                        <label className={` ${item.url === '/' ? 'hidden' : ''} w-16 h-8 flex items-center justify-center`}>
                                                            <input
                                                                type="checkbox"
                                                                className="cursor-pointer"
                                                                checked={field.value}
                                                                onChange={e => field.onChange(e.target.checked)}
                                                                onBlur={field.onBlur}
                                                                name={field.name}
                                                                ref={field.ref}
                                                            />
                                                            <span></span>
                                                        </label>
                                                    )}
                                                />
                                            ) : <span className={`font-normal text-[12px] text-[#9CA3AF]`}>N/A</span>}
                                        </div>
                                        <div className={`flex items-center justify-center min-w-16 w-16 max-w-16 min-h-8 max-h-8 border border-[#E5E7EB] ${!item.checked ? `pointer-events-none opacity-50` : ``}`}>
                                            {typeof item.entities[1] !== 'undefined' && (!item.entities[1]?.disable || (item.entities[1]?.disable && !item.entities[1].disable)) ? (
                                                <Controller
                                                    name={`permission.${idx}.entities.${1}.checked`}
                                                    control={control}
                                                    render={({ field }) => (
                                                        <label className={`${item.url === '/' ? 'hidden' : ''} w-16 h-8 flex items-center justify-center`}>
                                                            <input
                                                                type="checkbox"
                                                                className="cursor-pointer"
                                                                checked={field.value}
                                                                onChange={e => field.onChange(e.target.checked)}
                                                                onBlur={field.onBlur}
                                                                name={field.name}
                                                                ref={field.ref}
                                                            />
                                                            <span></span>
                                                        </label>
                                                    )}
                                                />
                                            ) : <span className={`font-normal text-[12px] text-[#9CA3AF]`}>N/A</span>}
                                        </div>
                                        <div className={`flex items-center justify-center min-w-16 w-16 max-w-16 min-h-8 max-h-8 border border-[#E5E7EB] ${!item.checked ? `pointer-events-none opacity-50` : ``}`}>
                                            {typeof item.entities[2] !== 'undefined' && (!item.entities[2]?.disable || (item.entities[2]?.disable && !item.entities[2].disable)) ? (
                                                <Controller
                                                    name={`permission.${idx}.entities.${2}.checked`}
                                                    control={control}
                                                    render={({ field }) => (
                                                        <label className={`${item.url === '/' ? 'hidden' : ''} w-16 h-8 flex items-center justify-center`}>
                                                            <input
                                                                type="checkbox"
                                                                className="cursor-pointer"
                                                                checked={field.value}
                                                                onChange={e => field.onChange(e.target.checked)}
                                                                onBlur={field.onBlur}
                                                                name={field.name}
                                                                ref={field.ref}
                                                            />
                                                            <span></span>
                                                        </label>
                                                    )}
                                                />
                                            ) : <span className={`font-normal text-[12px] text-[#9CA3AF]`}>N/A</span>}
                                        </div>
                                        <div className={`flex items-center justify-center min-w-32 w-32 max-w-32 min-h-8 max-h-8 border border-[#E5E7EB] px-2 py-1 ${!item.checked ? `pointer-events-none opacity-50` : ``}`}><a className={`${item.url === `/` ? `pointer-events-none opacity-50` : ``}`} onClick={() => {
                                            setSelectedUserModule({
                                                item,
                                                key: idx
                                            });
                                            if (userAdditionalSettingsRef.current) {
                                                userAdditionalSettingsRef.current.open();
                                            }
                                        }}><Icon name={`settings`} size={1} /></a></div>
                                    </div>
                                </div>
                            ))}
                            {permissionWatcher.length < 1 && (
                                <div className={`font-normal p-3 border border-dashed border-gray-300 h-40 flex items-center justify-center mt-4 rounded bg-gray-50`}>No modules added yet!</div>
                            )}
                        </div>
                    </div>
                </div>

                <ModalWrapper ref={userAdditionalSettingsRef}>
                    <div className={`relative min-h-[359px]`}>
                        <div className={``}>
                            <h4 className={`font-bold text-lg pl-0 pr-0 mb-4 modal-header`}>{selectedUserModule && selectedUserModule?.item ? `Special access of ${selectedUserModule?.item.name}` : `Special access`}</h4>
                            <div className={`max-h-80 min-h-64 overflow-auto`}>
                                {selectedUserModule && selectedUserModule?.item && selectedUserModule.item.entities && selectedUserModule.item.entities.length > 0 && selectedUserModule.item.entities.filter((o: any) => o?.obj && o.obj && ![`add`, `edit`, `delete`].includes(slugifyEntity(o.obj))).length > 0 ? (
                                    <div className={`space-y-2 pr-2`}>
                                        {selectedUserModule.item.entities.map((entity: any, eidx: number) => (
                                            <>
                                                {entity?.obj && entity.obj && (
                                                    <div key={eidx} className={`${![`add`, `edit`, `delete`].includes(slugifyEntity(entity.obj)) ? `` : `hidden`}`}>
                                                        <Controller
                                                            name={`permission.${selectedUserModule.key}.entities.${eidx}.checked`}
                                                            control={control}
                                                            render={({ field }) => (
                                                                <label className={`flex items-center gap-3 bg-slate-50 rounded p-2 border border-slate-300 ${entity.disable ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}>
                                                                    <input
                                                                        type="checkbox"
                                                                        className="cursor-pointer"
                                                                        checked={field.value}
                                                                        onChange={e => {
                                                                            if (!entity.disable) {
                                                                                field.onChange(e.target.checked);
                                                                            }
                                                                        }}
                                                                        onBlur={field.onBlur}
                                                                        name={field.name}
                                                                        ref={field.ref}
                                                                        disabled={entity.disable}
                                                                    />
                                                                    <span>{entity.obj}</span>
                                                                </label>
                                                            )}
                                                        />
                                                    </div>
                                                )}
                                            </>
                                        ))}
                                    </div>
                                ) : (
                                    <p className={`font-normal p-3 border border-dashed border-gray-300 h-40 flex items-center justify-center mt-4 rounded bg-gray-50`}>No entities found</p>
                                )}
                            </div>
                            {selectedUserModule && selectedUserModule?.item && selectedUserModule.item.entities && selectedUserModule.item.entities.length > 0 && (
                                <div className={`flex justify-end gap-2 mt-5`}>
                                    <Button type="button" theme={`secondary`} onClick={() => {
                                        setSelectedUserModule(null);
                                        if (userAdditionalSettingsRef.current) {
                                            userAdditionalSettingsRef.current.close();
                                        }
                                    }}>Cancel</Button>
                                    <Button type="button" onClick={() => {
                                        setSelectedUserModule(null);
                                        if (userAdditionalSettingsRef.current) {
                                            userAdditionalSettingsRef.current.close();
                                        }
                                    }}>Submit</Button>
                                </div>
                            )}
                        </div>
                    </div>
                </ModalWrapper>

                <div className={`flex justify-end gap-2 flex-shrink-0 pt-4 border-t border-gray-200 mt-6`}>
                    <hr className={`border-gray-900 mb-4`} />
                    <div className={`flex justify-end gap-2`}>
                        <Button type='submit'>Save Settings</Button>
                        <Button theme='secondary' childstyle={{ paddingLeft: '20px', paddingRight: '20px' }} onClick={() => onCancel()}>Cancel</Button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default UserSettingsForm;
